import { render, staticRenderFns } from "./BrokerageDetailList.vue?vue&type=template&id=6c310dc4&scoped=true"
import script from "./BrokerageDetailList.vue?vue&type=script&lang=js"
export * from "./BrokerageDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c310dc4",
  null
  
)

export default component.exports